export default __webpack_public_path__ + "static/media/Alchemist_Bundles_Preview.13bfaeda.mp4";